import { useTranslation } from "react-i18next";

import { DEFAULT_FILTER_TYPE } from "features/ui/Filters/constants";
import OperatorsDropdown from "features/ui/Filters/other/OperatorsDropdown";
import { FilterOperator, FilterType } from "features/ui/Filters/types";
import {
  getFirstAvailableSelectedOperator,
  operatorToSelectOption,
} from "features/ui/Filters/utils";
import { SchemaEntry } from "features/ui/MaterialTable";
import { SelectOption } from "features/ui/Select";

interface Props {
  selected: FilterOperator | null;
  onChange: (selected: FilterOperator) => void;
  attributeSchema?: SchemaEntry<string>;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  fullWidth?: boolean;
  isInsideFilterBuilder?: boolean;
}

const OperatorSelect = ({
  selected,
  onChange,
  attributeSchema,
  disabled,
  autoFocus,
  className,
  fullWidth,
  isInsideFilterBuilder = false,
}: Props) => {
  const { t } = useTranslation("filters");
  const currentAttributeType: FilterType =
    attributeSchema?.filter?.filterType || DEFAULT_FILTER_TYPE;

  const currentSelectedOperator = getFirstAvailableSelectedOperator(
    t,
    selected,
    currentAttributeType,
    attributeSchema
  );

  const selectedOperatorOption: SelectOption<FilterOperator> =
    operatorToSelectOption(t, currentAttributeType, currentSelectedOperator);

  const currentAttributeFilterProperties = attributeSchema?.filter;

  return (
    <OperatorsDropdown
      fullWidth={fullWidth}
      className={className}
      autoFocus={autoFocus}
      type={currentAttributeType}
      selected={selectedOperatorOption}
      onChange={(selected) => onChange(selected.id)}
      disabled={disabled}
      isInsideFilterBuilder={isInsideFilterBuilder}
      {...currentAttributeFilterProperties}
    />
  );
};

export default OperatorSelect;
